export default "__VITE_ASSET__cb589bba__"